import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { subscribeProducts } from "../lib/dataStore";
import ProductCard from "../components/ProductCard";

const CATS = ["All", "Leather Bags", "Cotton Bags", "Accessories"];

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const active = params.get("cat") || "All";
  const q = params.get("q") || "";

  useEffect(() => {
    const unsub = subscribeProducts(setProducts);
    return () => unsub && unsub();
  }, []);

  const filtered = useMemo(() => {
    return products.filter((p) => {
      const catOk = active === "All" || p.category === active;
      const qOk = !q || p.name.toLowerCase().includes(q.toLowerCase()) || p.description?.toLowerCase().includes(q.toLowerCase());
      return catOk && qOk;
    });
  }, [products, active, q]);

  const setCat = (c) => {
    const p = new URLSearchParams(params);
    if (c === "All") p.delete("cat"); else p.set("cat", c);
    setParams(p);
  };

  return (
    <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-10 py-8 sm:py-16">
      <div className="mb-8 sm:mb-12">
        <div className="overline text-terracotta mb-2">The Shop</div>
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-serif tracking-tight">Bags, totes &amp; keepsakes</h1>
        <p className="text-muted-foreground mt-2 sm:mt-4 max-w-2xl text-sm sm:text-base">Each piece is one of a small batch. When it's gone, it's gone.</p>
      </div>
      <div className="flex flex-wrap items-center gap-2 sm:gap-3 mb-6 sm:mb-8">
        {CATS.map((c) => (
          <button
            key={c}
            data-testid={`cat-${c.replace(/\s+/g, "-").toLowerCase()}`}
            onClick={() => setCat(c)}
            className={`px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm border transition-colors ${active === c ? "bg-foreground text-background border-foreground" : "border-border hover:border-foreground"}`}
          >
            {c}
          </button>
        ))}
        <input
          data-testid="search-input"
          value={q}
          onChange={(e) => {
            const p = new URLSearchParams(params);
            if (e.target.value) p.set("q", e.target.value); else p.delete("q");
            setParams(p);
          }}
          placeholder="Search products…"
          className="ml-auto bg-muted/60 border border-border px-3 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm rounded-full outline-none focus:border-foreground w-full sm:w-64"
        />
      </div>
      {filtered.length === 0 ? (
        <div className="text-center py-24 text-muted-foreground">No products match. Try another category.</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-6">
          {filtered.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
